import { Box } from "@mui/material";
import { JobMapProps } from "./JobMap.types";
import { useJobMapViewModel } from "./JobMap.vm";
import { JobMapToolbar } from "./JobMap.toolbar";
import { JobMapMap } from "./JobMap.map";

export default function JobMap(props: JobMapProps) {
	const vm = useJobMapViewModel(props);

	if (vm.showToolbar) {
		return (
			<Box
				sx={{
					height: vm.resolvedHeight ?? "100%",
					width: "100%",
					display: "flex",
					flexDirection: "column",
				}}
			>
				<JobMapToolbar vm={vm} props={props} />
				<Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
					<JobMapMap vm={vm} />
				</Box>
			</Box>
		);
	}

	return <JobMapMap vm={vm} />;
}
